import { useEffect, useMemo, useState } from 'react';
import { ZOOM } from '../../../types/CallSourceTypes';
import { getEngagementData } from '../../clients/getEngagementData';
export const useZoomExternalAccountId = ({
  engagementId,
  externalAccountId,
  source
}) => {
  const [fetchedExternalAccountId, setFetchedExternalAccountId] = useState(externalAccountId || null);
  useEffect(() => {
    if (!engagementId || source !== ZOOM || externalAccountId) return () => {};
    let mounted = true;
    getEngagementData(engagementId).then(data => {
      if (mounted) {
        var _data$metadata;
        setFetchedExternalAccountId(((_data$metadata = data.metadata) === null || _data$metadata === void 0 ? void 0 : _data$metadata.externalAccountId) || null);
      }
    })
    // In the case of a zoom error we just don't end up with an
    // external account id and there's no refresh.
    .catch(() => {});
    return () => {
      mounted = false;
    };
  }, [engagementId, externalAccountId, source]);
  return useMemo(() => fetchedExternalAccountId || externalAccountId, [fetchedExternalAccountId, externalAccountId]);
};